import type { AuthRepository, SnsSignUpCommand } from '../repository/AuthRepository';
import type { AuthSession } from '../entity/AuthTypes';

export class SnsSignUpUseCase {
  constructor(private readonly repository: AuthRepository) {}

  async execute(command: SnsSignUpCommand): Promise<AuthSession> {
    if (!command.ticket) throw new Error('ticket is required');
    if (!command.email?.trim()) throw new Error('email is required');

    return this.repository.snsSignUp({
      ...command,
      email: command.email.trim(),
      organization: command.organization?.trim() || undefined,
      name: command.name?.trim() || undefined,
      phone: command.phone?.trim() || undefined,
    });
  }
}
